<template>
  <a-spin :spinning="loading">
    <a-descriptions :column="3" style="margin-bottom: -15px">
      <a-descriptions-item :label="$t('business.label.storerName')">
        <span class="normalFont">{{order.storer.name}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.invoiceTime')">
        <span class="normalFont">{{order.invoiceTime}}</span>
      </a-descriptions-item>
      <a-descriptions-item>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.receiptOrderNo')">
        <span class="normalFont">{{order.no}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.supplier')">
        <span class="normalFont">{{order.customer.name}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.orderStatus')">
        <span class="normalFont">{{order.orderStatus !== null && order.orderStatus !== undefined ? orderStatusData.find(item => item.ordinal === order.orderStatus).name : null}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.orderType')">
        <span class="normalFont">{{order.orderType.name}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.dataSource')">
        <span class="normalFont">{{order.dataSource !== null && order.dataSource !== undefined ? dataSources.find(item => item.ordinal === order.dataSource).name : null}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.maker')">
        <span class="normalFont">{{order.operator}}</span>
      </a-descriptions-item>
    </a-descriptions>
    <vxe-table
      border
      stripe
      round
      show-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="details"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="200"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="200"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="asnDetail.lotNo" title="business.label.lot" width="150"/>
      <vxe-column field="asnDetail.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="asnDetail.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="asnDetail.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="purchaseOrder.no" title="business.label.purchaseOrderNo" width="150"/>
      <vxe-column field="asnDetail.quantity" title="business.label.plannedQuantity" width="150"/>
      <vxe-column field="asnDetail.receivedQuantity" title="business.label.receivedQuantity" width="150"/>
      <vxe-column field="asnDetail.acceptedQuantity" title="business.label.acceptedQuantity" width="150"/>
    </vxe-table>
  </a-spin>
</template>

<script>
import { findAll, findEnum } from '@/api/Api'
import { AsnOrder } from '@/api/dto/order/AsnOrder'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'ReceivingCloseDetail',
    data() {
      return {
        loading: false,
        dataSources: [],
        order: new AsnOrder(),
        details: [],
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.74)// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    props: {
      orderStatusData: {
        type: Array,
        default: []
      }
    },
    created() {
      findEnum('DataSource').then(res => {
        if (res.success) {
          this.dataSources = res.result
        }
      })
    },
    methods: {
      getData(row) {
        if (row) {
          this.order.no = row.asnOrder.no
        }
        if (this.order.no === null || this.order.no === undefined) {
          return this.$message.warning('请先选择单据')
        }
        this.loading = true
        findAll('asnDetailFactory', { no: this.order.no }).then(res => {
          if (res.success) {
            this.details = res.result
          }
          setTimeout(() => {
            this.loading = false
          }, 200)
        }).finally(() => this.loading = false)
      },
      clear() {
        this.order = new AsnOrder()
        this.details = []
      }
    }
  }
</script>
<style scoped>
  .normalFont {
    font-weight: bold;
    color: #404040;
  }
</style>